<template>
  <div>
    <div class="adm-card">
      <div class="adm-card-head">
        <div class="adm-card-title">
          <span class="adm-card-title-bar" />邀请码列表
          <span class="adm-card-title-extra">共 {{ total }} 个</span>
        </div>
      </div>

      <div class="adm-filter">
        <el-input
          v-model="query.code"
          class="adm-w180"
          name="code"
          autocomplete="off"
          placeholder="邀请码"
          clearable
          @keyup.enter.native="onSearch"
        />
        <el-input
          v-model="query.batchNo"
          class="adm-w180"
          name="batchNo"
          autocomplete="off"
          placeholder="批次号"
          clearable
          @keyup.enter.native="onSearch"
        />
        <el-select v-model="query.status" class="adm-w140" placeholder="全部状态" clearable>
          <el-option label="未使用" value="UNUSED" />
          <el-option label="已用完" value="USED" />
          <el-option label="已禁用" value="DISABLED" />
          <el-option label="已过期" value="EXPIRED" />
        </el-select>
        <el-button type="primary" icon="el-icon-search" :loading="loading" @click="onSearch">
          查询
        </el-button>
        <el-button icon="el-icon-refresh-left" @click="onReset">重置</el-button>
        <span class="adm-filter-spacer" />
        <el-button type="primary" icon="el-icon-plus" @click="openGenerate">生成邀请码</el-button>
      </div>

      <div v-if="selection.length" class="adm-batch">
        <span class="adm-batch-text">已选 <b>{{ selection.length }}</b> 项</span>
        <el-button
          size="small"
          :loading="batching"
          @click="onBatchStatus('DISABLED')"
        >批量禁用</el-button>
        <el-button
          size="small"
          :loading="batching"
          @click="onBatchStatus('UNUSED')"
        >批量启用</el-button>
        <el-button
          size="small"
          type="danger"
          plain
          :loading="batching"
          @click="onBatchDelete"
        >批量删除</el-button>
        <span class="adm-filter-spacer" />
        <el-button size="small" type="text" @click="clearSelection">取消选择</el-button>
      </div>

      <el-table
        ref="table"
        v-loading="loading"
        :data="rows"
        border
        @selection-change="onSelectionChange"
      >
        <el-table-column type="selection" width="46" />
        <el-table-column prop="code" label="邀请码" width="150">
          <template slot-scope="{ row }">
            <span class="adm-code">{{ row.code }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="batchNo" label="批次号" width="150" />
        <el-table-column label="状态" width="90">
          <template slot-scope="{ row }">
            <el-tag :type="statusTagType(row.status)" size="mini">
              {{ statusText(row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="用量" width="90">
          <template slot-scope="{ row }">
            {{ row.usedCount }} / {{ row.maxUseCount === 0 ? '不限' : row.maxUseCount }}
          </template>
        </el-table-column>
        <el-table-column label="有效期至" width="150">
          <template slot-scope="{ row }">
            {{ row.validUntil ? formatTime(row.validUntil) : '长期' }}
          </template>
        </el-table-column>
        <el-table-column label="最后使用" width="150">
          <template slot-scope="{ row }">{{ formatTime(row.lastUsedAt) }}</template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="130" show-overflow-tooltip />
        <el-table-column label="操作" width="170" fixed="right">
          <template slot-scope="{ row }">
            <div class="adm-op-actions">
              <el-link type="primary" :underline="false" @click="openUsages(row)">明细</el-link>
              <el-link
                v-if="row.status === 'UNUSED'"
                type="warning"
                :underline="false"
                @click="onToggleStatus(row, 'DISABLED')"
              >禁用</el-link>
              <el-link
                v-else-if="row.status === 'DISABLED'"
                type="primary"
                :underline="false"
                @click="onToggleStatus(row, 'UNUSED')"
              >启用</el-link>
              <el-link type="danger" :underline="false" @click="onDelete(row)">删除</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <AdmPager
        :total="total"
        :page="query.page"
        :size="query.size"
        @page-change="onPageChange"
        @size-change="onSizeChange"
      />
    </div>

    <el-dialog title="生成邀请码" :visible.sync="generateVisible" width="480px" append-to-body>
      <el-form label-width="112px">
        <el-form-item label="生成数量">
          <el-input-number v-model="genForm.count" :min="1" :max="500" />
          <div class="adm-inline-hint">单次最多 500 个</div>
        </el-form-item>
        <el-form-item label="单码可用次数">
          <el-input-number v-model="genForm.maxUseCount" :min="0" />
          <div class="adm-inline-hint">0 表示不限次数</div>
        </el-form-item>
        <el-form-item label="有效天数">
          <el-input-number v-model="genForm.validDays" :min="0" />
          <div class="adm-inline-hint">0 表示长期有效</div>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="genForm.remark"
            name="remark"
            autocomplete="off"
            maxlength="200"
            placeholder="发给谁、用途"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="generateVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="generateLoading" @click="submitGenerate">
          生成
        </el-button>
      </div>
    </el-dialog>

    <el-dialog title="本批生成的邀请码" :visible.sync="resultVisible" width="520px" append-to-body>
      <div class="adm-alert">
        <i class="el-icon-info" />
        <span>
          批次号 <b>{{ result.batchNo }}</b>，共 {{ result.count }} 个。
          请立即复制留存，关闭后只能按批次号或邀请码逐个查询。
        </span>
      </div>
      <el-input
        class="adm-codes"
        type="textarea"
        :rows="10"
        readonly
        :value="(result.codes || []).join('\n')"
      />
      <div slot="footer">
        <el-button size="small" icon="el-icon-document-copy" @click="copyCodes">复制</el-button>
        <el-button size="small" type="primary" @click="resultVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog title="使用明细" :visible.sync="usagesVisible" width="720px" append-to-body>
      <el-table :data="usages" border>
        <el-table-column prop="code" label="邀请码" width="150">
          <template slot-scope="{ row }">
            <span class="adm-code">{{ row.code }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="userId" label="使用人 ID" width="180">
          <template slot-scope="{ row }">
            <span class="adm-code">{{ row.userId }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="usedIp" label="IP" min-width="130" />
        <el-table-column label="使用时间" width="150">
          <template slot-scope="{ row }">{{ formatTime(row.createdAt) }}</template>
        </el-table-column>
      </el-table>
      <div v-if="!usages.length" class="adm-empty">
        <i class="el-icon-folder-opened" />该邀请码还没有被使用
      </div>
      <div slot="footer">
        <el-button size="small" @click="usagesVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  fetchInviteCodes,
  generateInviteCodes,
  changeInviteCodeStatus,
  deleteInviteCode,
  batchInviteCodeStatus,
  batchDeleteInviteCodes,
  fetchInviteCodeUsages,
  isOk
} from '@/api/admin'
import AdmPager from '@/components/admin/AdmPager.vue'

export default {
  name: 'InviteCodePanel',
  components: { AdmPager },
  data() {
    return {
      query: { code: '', batchNo: '', status: '', page: 1, size: 20 },
      rows: [],
      total: 0,
      loading: false,
      generateVisible: false,
      generateLoading: false,
      genForm: { count: 20, maxUseCount: 1, validDays: 0, remark: '' },
      resultVisible: false,
      result: { batchNo: '', codes: [], count: 0 },
      usagesVisible: false,
      usages: [],
      selection: [],
      batching: false
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      this.loading = true
      fetchInviteCodes(this.query)
        .then(res => {
          if (!isOk(res)) {
            throw new Error(res && res.message ? res.message : '查询失败')
          }
          this.rows = res.data.list || []
          this.total = Number(res.data.total || 0)
          // 换页 / 重新查询后清空勾选：残留的 id 可能已不在当前列表里，
          // 继续拿去做批量操作会让人不知道到底动了哪些数据
          this.clearSelection()
        })
        .catch(err => {
          this.$message.error(err.message || '查询失败')
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSearch() {
      this.query.page = 1
      this.load()
    },
    onReset() {
      this.query = { code: '', batchNo: '', status: '', page: 1, size: 20 }
      this.load()
    },
    onPageChange(page) {
      this.query.page = page
      this.load()
    },
    onSizeChange(size) {
      this.query.size = size
      this.query.page = 1
      this.load()
    },
    openGenerate() {
      this.genForm = { count: 20, maxUseCount: 1, validDays: 0, remark: '' }
      this.generateVisible = true
    },
    submitGenerate() {
      if (this.generateLoading) return
      this.generateLoading = true
      generateInviteCodes(this.genForm)
        .then(res => {
          if (!isOk(res)) {
            throw new Error(res && res.message ? res.message : '生成失败')
          }
          this.result = res.data
          this.generateVisible = false
          this.resultVisible = true
          this.onSearch()
        })
        .catch(err => {
          this.$message.error(err.message || '生成失败')
        })
        .finally(() => {
          this.generateLoading = false
        })
    },
    onToggleStatus(row, status) {
      const disabling = status === 'DISABLED'
      const action = disabling ? '禁用' : '启用'
      this.$confirm(`确定${action}邀请码「${row.code}」吗？`, `${action}邀请码`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => changeInviteCodeStatus(row.id, status))
        .then(res => {
          if (!isOk(res)) {
            throw new Error(res && res.message ? res.message : `${action}失败`)
          }
          this.$message.success(`${action}成功`)
          this.load()
        })
        .catch(err => {
          if (err === 'cancel' || err === 'close') return
          this.$message.error((err && err.message) || `${action}失败`)
        })
    },
    onDelete(row) {
      this.$confirm(
        `删除后该码将不再出现在列表中，且无法恢复。确定删除「${row.code}」吗？`,
        '删除邀请码',
        { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }
      )
        .then(() => deleteInviteCode(row.id))
        .then(res => {
          if (!isOk(res)) {
            throw new Error(res && res.message ? res.message : '删除失败')
          }
          this.$message.success('已删除')
          this.load()
        })
        .catch(err => {
          if (err === 'cancel' || err === 'close') return
          this.$message.error((err && err.message) || '删除失败')
        })
    },
    onSelectionChange(rows) {
      this.selection = rows || []
    },
    clearSelection() {
      const table = this.$refs.table
      if (table) table.clearSelection()
      this.selection = []
    },
    selectedIds() {
      return this.selection.map(row => row.id)
    },
    /**
     * 批量启用 / 禁用。
     * 后端「尽力而为」：状态不允许的码只计入 skipped，不会整批失败，
     * 所以这里把生效数和跳过数都回显出来，避免用户以为全部成功了。
     */
    onBatchStatus(status) {
      if (this.batching || !this.selection.length) return
      const disabling = status === 'DISABLED'
      const action = disabling ? '禁用' : '启用'
      this.$confirm(
        `确定批量${action}选中的 ${this.selection.length} 个邀请码吗？`
          + '已用尽 / 已过期 / 状态本就相同的码会被自动跳过。',
        `批量${action}邀请码`,
        { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }
      )
        .then(() => {
          this.batching = true
          return batchInviteCodeStatus(this.selectedIds(), status)
        })
        .then(res => {
          if (!isOk(res)) {
            throw new Error(res && res.message ? res.message : `${action}失败`)
          }
          const success = Number(res.data.success || 0)
          const skipped = Number(res.data.skipped || 0)
          this.$message.success(
            `已${action} ${success} 个` + (skipped > 0 ? `，跳过 ${skipped} 个` : '')
          )
          this.load()
        })
        .catch(err => {
          if (err === 'cancel' || err === 'close') return
          this.$message.error((err && err.message) || `${action}失败`)
        })
        .finally(() => {
          this.batching = false
        })
    },
    onBatchDelete() {
      if (this.batching || !this.selection.length) return
      this.$confirm(
        `删除后这些码将不再出现在列表中，且无法恢复。确定删除选中的 ${this.selection.length} 个邀请码吗？`,
        '批量删除邀请码',
        { confirmButtonText: '确定删除', cancelButtonText: '取消', type: 'warning' }
      )
        .then(() => {
          this.batching = true
          return batchDeleteInviteCodes(this.selectedIds())
        })
        .then(res => {
          if (!isOk(res)) {
            throw new Error(res && res.message ? res.message : '删除失败')
          }
          const success = Number(res.data.success || 0)
          const skipped = Number(res.data.skipped || 0)
          this.$message.success(
            `已删除 ${success} 个` + (skipped > 0 ? `，跳过 ${skipped} 个` : '')
          )
          this.load()
        })
        .catch(err => {
          if (err === 'cancel' || err === 'close') return
          this.$message.error((err && err.message) || '删除失败')
        })
        .finally(() => {
          this.batching = false
        })
    },
    openUsages(row) {
      fetchInviteCodeUsages(row.id, { page: 1, size: 100 })
        .then(res => {
          if (!isOk(res)) {
            throw new Error(res && res.message ? res.message : '获取明细失败')
          }
          this.usages = res.data.list || []
          this.usagesVisible = true
        })
        .catch(err => {
          this.$message.error(err.message || '获取明细失败')
        })
    },
    /**
     * 复制本批邀请码。
     * 用 execCommand 而不是 Clipboard API：后者在非 HTTPS / 非安全上下文下不可用，
     * 而内网后台既有 https 也有 http。
     */
    copyCodes() {
      const text = (this.result.codes || []).join('\n')
      if (!text) {
        this.$message.warning('没有可复制的邀请码')
        return
      }
      const area = document.createElement('textarea')
      area.value = text
      area.style.position = 'fixed'
      area.style.opacity = '0'
      document.body.appendChild(area)
      area.select()
      try {
        const ok = document.execCommand('copy')
        if (ok) {
          this.$message.success('已复制到剪贴板')
        } else {
          this.$message.error('复制失败，请手动选中复制')
        }
      } catch (e) {
        this.$message.error('复制失败，请手动选中复制')
      } finally {
        document.body.removeChild(area)
      }
    },
    statusText(status) {
      const map = { UNUSED: '未使用', USED: '已用完', DISABLED: '已禁用', EXPIRED: '已过期' }
      return map[status] || status || '-'
    },
    statusTagType(status) {
      if (status === 'UNUSED') return 'success'
      if (status === 'DISABLED') return 'danger'
      if (status === 'EXPIRED') return 'warning'
      return 'info'
    },
    formatTime(value) {
      if (!value) return '-'
      return String(value).replace('T', ' ').slice(0, 16)
    }
  }
}
</script>

<style scoped>
/* 卡片 / 筛选栏 / 分页样式统一来自 @/styles/admin.css */
.adm-w180 {
  width: 180px;
}

.adm-w140 {
  width: 140px;
}

.adm-codes {
  margin-top: 12px;
}

/* 批量操作条：只在有勾选时出现，钉在表格上方 */
.adm-batch {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 12px 20px;
  border-bottom: 1px solid var(--adm-border, #f0f0f0);
  background: var(--adm-primary-bg, #e6f4ff);
}

.adm-batch-text {
  font-size: 13px;
  color: var(--adm-text-2, rgba(0, 0, 0, 0.65));
}

.adm-batch-text b {
  margin: 0 2px;
  color: var(--adm-primary, #1677ff);
}

.adm-codes .el-textarea__inner {
  font-family: Consolas, Monaco, 'Courier New', monospace;
  font-size: 13px;
  line-height: 1.7;
}
</style>
